import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IResponse } from "@app/lib/models/response.model";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from "rxjs";
import { CaseDataPayload, DocType, IDRattachementParams, IDRAttachment, IDRCaseCommentsDTO, IDRCaseDocument, IDRCaseSearchRequestBody, IDRlistOfFiles, IDRlistOfFilesParams, IDRmotionCaseNumber, IDRmotionCaseNumberParams, IDRPartiesDTO, IDRPartyRepresentationDTO, modifyDocPayLoad, PrintRecieptRequest } from "../models/document-reception.model";
import { ICaseItem, ICaseSearchRequestBody, ISearchRequestParams } from "../models/case-assignment.model";
import { TAny } from "@app/lib/models/common.type";
import { Party } from "../models/document-details.model";

@Injectable({
  providedIn: 'root'
})
export class DocumentReceptionService extends BaseHttpService {

  private baseUrl: string;
  constructor(http: HttpClient, appConfig: AppConfiguration) {
    super(http, appConfig);
    this.baseUrl = this.appConfig.hostUrl;
  }

  /**
   * Search Case By case information
   * @param reqBody 
   * @param queryParams 
   * @returns 
   */
  searchCaseDetailsIDR(reqBody: IDRCaseSearchRequestBody) {
    return this.post<IResponse<IDRCaseDocument[]>, IDRCaseSearchRequestBody>(
      'documents-reception/case/documents/search.htm',
      reqBody
    ).pipe(
      map((res: IResponse<IDRCaseDocument[]>) => res.data || [])
    );
  }


  searchCaseNumber(reqBody: ICaseSearchRequestBody, queryParams: ISearchRequestParams): Observable<IResponse<ICaseItem[]>> {
    return this.post<IResponse<ICaseItem[]>, ICaseSearchRequestBody>('case/search/by/case-number.htm', reqBody, { params: { ...queryParams } });
  }


  searchCaseNumberBasedprefix(reqBody: ICaseSearchRequestBody, queryParams: ISearchRequestParams): Observable<IResponse<ICaseItem[]>> {
    return this.post<IResponse<ICaseItem[]>, ICaseSearchRequestBody>('case/search/by-case-number-pattern.htm', reqBody,);
  }
  public getDocs(queryParams: IDRattachementParams) {
    return this.get<IResponse<IDRAttachment[]>>(
      'documents-reception/case/attachments.htm',
      { params: { ...queryParams } }
    );
  }
  getdocList() {
    return this.get<IResponse<DocType[]>>('documents-reception/case/doc-types.htm');
  }
  public getListOfFiles(queryParams: IDRlistOfFilesParams, reqBody: TAny) {
    return this.post<IResponse<IDRlistOfFiles[]>, TAny>(
      'case/files.htm', reqBody,
      { params: { ...queryParams } }
    );
  }
  public getMotionCaseNumber(queryParams: IDRmotionCaseNumberParams) {
    return this.get<IResponse<IDRmotionCaseNumber[]>>(
      'case/motions.htm',
      { params: { ...queryParams } }
    );
  }
  public getComments(queryParams: IDRlistOfFilesParams, reqBody: TAny) {
    return this.post<IResponse<IDRCaseCommentsDTO[]>, TAny>(
      'case/comments.htm', reqBody,
      { params: { ...queryParams } }
    );
  }
  downloadFile(queryParams: TAny) {
    return this.get('documentsController/downloadFile.htm', { params: { ...queryParams } });
  }
  searchParties(reqBody: TAny) {
    return this.post<IResponse<IDRPartiesDTO[]>, TAny>('parties/from/group.htm', reqBody);
  }
  sentMail(reqBody: TAny) {
    return this.post<IResponse<TAny>, TAny>('documents/send/mail.htm', reqBody);
  }
  searchCounsels(reqBody: TAny) {
    return this.post<IResponse<IDRPartyRepresentationDTO[]>, TAny>('documents-reception/caseid/counsels.htm', reqBody);
  }
  uploadFile(formData: FormData, queryParams: {} = {}) {
    return this.post<IResponse<TAny>, TAny>('documents/uploadFile.htm', formData, { params: { ...queryParams } });
  }
  getcounsilPartyList(queryParams: TAny) {
    return this.get<IResponse<Party[]>>('case/counsel/list.htm', { params: { ...queryParams } });
  }

  getwitnessPartyList(queryParams: TAny) {
    return this.get<IResponse<Party[]>>('case/witness/list.htm', { params: { ...queryParams } });
  }
  getaddedPartyList(queryParams: TAny) {
    return this.get<IResponse<Party[]>>('parties/by/caseid.htm', { params: { ...queryParams } });
  }
  searchPartiesIdName(body: TAny,) {
    return this.post<IResponse<Party[]>, TAny>('parties/by/id.htm', body);
  }

  searchCousel(reqBody: TAny) {
    return this.post('documents-reception/caseid/counsels.htm', reqBody);
  }
  deleteAttachment(reqBody: TAny) {
    return this.post<IResponse<TAny>, TAny>('documents/invalidate.htm', reqBody);
  }

  onCloseTask(reqBody: TAny) {
    return this.post<IResponse<TAny>, TAny>('tasks/close/triggered-task.htm', reqBody);
  }
  saveModification(reqBody: [CaseDataPayload]) {
    return this.post<IResponse<TAny>, [CaseDataPayload]>('/documents/subdoc/upsert.htm', reqBody);
  }
  // getPrintReceipt(queryparams:TAny): Observable<Blob> {
  //       return this.get('documentsController/printReceipt.htm',{params:{...queryparams}, responseType: 'blob' });
  //     }
  // }

  getPrintReceipt(reqBody: PrintRecieptRequest): Observable<Blob> {
    const url = `${this.baseUrl}documents-reception/print-receipt.htm`;
    return this.http.post<Blob>(url, reqBody, {
      responseType: 'blob' as 'json'
    });
  }
  updateDocParty(docModel: modifyDocPayLoad): Observable<TAny> {
    return this.post<IResponse<TAny>, modifyDocPayLoad>('documents-reception/documents/upsert.htm', docModel).pipe(
      tap(response => {
        console.log('Response:', response);  // Log the response here
      })
    );
  }
  private caseData = new BehaviorSubject<any>(null);
  currentCaseData = this.caseData.asObservable();

  setCaseData(data: any) {
    this.caseData.next(data);
  }
}